import { observer } from "mobx-react-lite";
import { useSearchStore, useViewSettingsStore } from "../..";
import useIsHalfScreenMap from "../../hooks/useIsHalfScreenMap";
import AccountLink from "../account/AccountLink";
import Search from "../search/Search";
import BaseMapDropdown from "./BaseMapDropdown";
import DrawDropdown from "./DrawDropdown";
import styles from './Header.module.css';
import MeasureDropdown from "./MeasureDropdown";

function Header() {
    const isHalfScreenMap = useIsHalfScreenMap();
    const searchStore = useSearchStore();
    const viewSettingsStore = useViewSettingsStore();

    return (
        <>
            <div className={[
                isHalfScreenMap ? styles.halfScreenContainer : styles.container,
                searchStore.isOpen ? styles.withSearchOpened : null,
            ].join(" ")}>
                <Search />
                {!viewSettingsStore.isMobile && <DrawDropdown />}
                {!viewSettingsStore.isMobile && <MeasureDropdown />}
                {!viewSettingsStore.isMobile && <BaseMapDropdown />}
            </div>
            <AccountLink />
        </>
    );
}

export default observer(Header);